import React from 'react';
import { Helmet } from 'react-helmet-async';
export default function SEO({ title, type }) {
    const description = "Buy your water credit anytime anywhere with PayWater"
    const customizedTitle = `Paywater | ${title}`
    const name = "Paywater"
    return (
        <Helmet>
            { /* Standard metadata tags */}
            <title>{customizedTitle}</title>
            <meta name='description' content={description} />
            { /* End standard metadata tags */}
            { /* Facebook tags */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={customizedTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={"https://www.paywater.ng"} />
            { /* End Facebook tags */}
            { /* Twitter tags */}
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content={type} />
            <meta name="twitter:title" content={customizedTitle} />
            <meta name="twitter:description" content={description} />
            { /* End Twitter tags */}
        </Helmet>
    )
}